import Effect from '../Effect/EffectBase';

/**
* 处理副作用基础功能队列
*/
class EffectQueue {
  constructor(props) {
    const data = props || {};

    this.init(data);
  }

  async init(props) {
    const { queue } = props;

    if (Array.isArray(queue)) {
      this.queue = queue;
      this.length = queue.length;
    } else {
      this.queue = new Array();
      this.length = 0;
    }
  }

  // 获取数据
  getData() {
    return this;
  }

  // 推入新副作用
  push(effect) {
    if (!effect instanceof Effect) throw new Error('请传递Effect对象');

    this.queue.push(effect);
    this.length++;

    return this.length;
  }

  // 删除最后一个
  pop() {
    const effect = this.queue.pop();
    this.length--;

    return effect;
  }

  // 清空
  clear() {
    this.queue = new Array();
    this.length = 0;
  }

  // 获取最后一个某个tag的副作用 不传则获取最后一个副作用数据
  getLastEffect(effectTag) {
    const { queue, length } = this;

    if (!effectTag) return queue[length - 1] || null;
    
    return queue.reverse().find(item => item.flag === effectTag) || [];
  }
}

export default EffectQueue;